import React, {FC, useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IDisplayUser, postNewSubscription } from '../../../common/async/AsyncCalls';
import { IUserState } from '../../../common/state/profile/user';
import { IGeneralInfoState } from '../../../common/state/subscriptions/general_info';
import { IPersonalInfo, IPersonalInfoState, PERSONAL_INFO_ACTION_TYPE } from '../../../common/state/subscriptions/personal_info';
import NavbarUser from '../../../components/navbar/Navbar.user';
import PersonalInfoForm from './panels/PersonalInfoForm';
import { useHistory } from 'react-router-dom';
import { addLocalStorageItem } from '../../../common/helpers/LocalStorage';
import { toast } from 'react-toastify';

// custom
const OfflineRegisterView : FC = () => {

    // states
    const history = useHistory();
    const token = useSelector(({user} : {user: IUserState}) => user.token);
    const userProfile: IDisplayUser = useSelector(({user}:{user: IUserState}) => user.profile);
    const eventTitle: string | undefined = useSelector(({general_info}:{general_info: IGeneralInfoState}) => general_info.selected?.event_title);
    const personalInfo: IPersonalInfo | undefined = useSelector(({personal_info}:{personal_info: IPersonalInfoState}) => personal_info.selected);    
    const generalInfo = useSelector(({general_info} : {
        general_info: IGeneralInfoState
    }) => general_info.selected);

    // actions    
    const personalInfoDispatch: (data: {type: PERSONAL_INFO_ACTION_TYPE, payload: any}) => void = useDispatch();
    // lifecycle
    const submitOfflineSubscription = useCallback(async (data: IPersonalInfo)=>{
        console.log('Offline submission details: ', generalInfo, data);
        if (!token || token === '' || !generalInfo || !data) return;
        try {
            const response = await postNewSubscription(token, {
                general_info: generalInfo,
                personal_info: data,
                payment_info: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    contact: '',
                    address: '',
                    city: '',
                    country: '',
                    pin_code: ''
                    }
            });
            toast(`Subscription record created!`);
            const {id} = response.data;
            if (id) addLocalStorageItem('subscription', id);
            history.push({pathname: '/offline_success'});
        } catch (err) {
            console.log('Error creating subscription record: ', err);
            toast(`Error creating subscription record!`);
        }
    },[token, generalInfo, personalInfo, history]);
    
    // evt handlers - personal info
    function handlePersonalInformation (data: IPersonalInfo) {        
        personalInfoDispatch({type: PERSONAL_INFO_ACTION_TYPE.INFO_SELECT, payload: data});
        console.log('PaymentFormData is: ', data);        
        submitOfflineSubscription(data);
    }    

    return <React.Fragment>
        <NavbarUser />
        <main
            className="flex flex-col items-center justify-start h-screen overflow-y-scroll text-gray-700 bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dartext-base">
                <p className="p-4 my-4 text-gray-700 dark:text-gray-300 dartext-base">
                    Register for <strong>{eventTitle}</strong>, submit the below form and we will call you!
                </p>
                <PersonalInfoForm 
                        defaultFormData={personalInfo ? personalInfo: {
                            first_name: generalInfo?.reg_type === 'self' ? userProfile.name?? '' : '',
                            last_name: '',
                            email: generalInfo?.reg_type === 'self' ? userProfile.email?? '': '',
                            contact: '',
                            address: '',
                            city: '',
                            country: '',
                            pin_code: '',
                            passport: ''
                        }} 
                        onSubmit={handlePersonalInformation}/> 
        </main>
    </React.Fragment>
};

export default OfflineRegisterView;